<template lang="pug">
span
  .ad-container(v-if="randomAd" :style="{ backgroundImage: 'url(' + randomAd.cover + ')' }")
    // p.sponsor-thanks.decorative-text Thanks to our Sponsor!
    img(v-if="randomAd.card" :src="randomAd.card" alt="Ad")
    p.sponsor-name(v-if="businesses.length") {{randomAd.name}}
    router-link.chip.chip-active(v-if="businesses.length" :to="{name: 'About', params: {listing: randomAd.link}}" tag="a") Visit Page

</template>

<script>

export default {
  name: 'adFeatured',
  data () {
    return {
      activeAd: ''
    }
  },
  computed: {
    adworthy () {
      return this.businesses.filter((element) => {
        return element.tier === '1'
      })
    },
    businesses () {
      return this.$store.getters.businesses
    },
    randomAd () {
      return this.adworthy[Math.floor(Math.random() * this.adworthy.length)]
    }
  },
  created () {
    this.$store.dispatch('loadedBusinesses')
  }
}
</script>

<style scoped lang="stylus">

.sponsor-thanks
  font-size 20px
  color white
  margin 15px
.sponsor-name
  font-size 25px
  margin 15px
img
  width 275px
  height 135px
  min-height 135px
  min-width 175px
  border-radius 10px
  overflow hidden
  
h3
  color white

h2
  text-shadow 2px 2px 5px #000

.btn
  font-size large
  color white

</style>
